import { LogLevel } from "@azure/msal-browser";

type EnvironmentType = "Local" | "Dev" | "Test" | "Prod";

const containerAppUris = {
  Dev: "https://ca-roles-privileges-cfg-dev-weu.greenisland-9557aaed.westeurope.azurecontainerapps.io",
  Test: "https://ca-roles-privileges-cfg-test-weu.politepebble-ac325973.westeurope.azurecontainerapps.io",
  Prod: "https://ca-roles-privileges-cfg-prod-weu.livelyground-f686889f.westeurope.azurecontainerapps.io",
};

const environmentUris = {
  Dev: "https://rolesprivileges.config.dev.nlys.dk",
  Test: "https://rolesprivileges.config.test.nlys.dk",
  Prod: "https://rolesprivileges.config.prod.nlys.dk",
};

const getEnvironmentFromUrl = (): EnvironmentType => {
  const currentUrl = window.location.href;
  if (currentUrl.includes(environmentUris.Dev) || currentUrl.includes(containerAppUris.Dev) ) {
    return "Dev";
  } else if (currentUrl.includes(environmentUris.Test) || currentUrl.includes(containerAppUris.Test)) {
    return "Test";
  } else if (currentUrl.includes(environmentUris.Prod) || currentUrl.includes(containerAppUris.Prod)) {
    return "Prod";
  } else {
    return "Local";
  }
};

const environment = getEnvironmentFromUrl();

// The application (client) IDs
const applicationIds = {
  Local: "1d5dda7f-1aba-4737-85ab-37e545b2bbb2",
  Dev: "1d5dda7f-1aba-4737-85ab-37e545b2bbb2",
  Test: "d0cbc042-9dc5-4abc-909a-67ad06091c28",
  Prod: "cc630c41-3c37-4347-8704-2d55c815bd7b",
};

// The URIs that is redirected to after a logout() call is made.
const postLogoutRedirectUris = {
  Local: "https://norlys.dk",
  Dev: "https://norlys.dk",
  Test: "https://norlys.dk",
  Prod: "https://norlys.dk",
};

// The URIs where the authorization code response is sent back to.
// By default, MSAL is configured to set the redirect URI to the current page that it is running on.
const redirectUris = {
  Local: "http://localhost:3000",
  Dev: "https://ca-roles-privileges-cfg-dev-weu.greenisland-9557aaed.westeurope.azurecontainerapps.io",
  Test: "https://ca-roles-privileges-cfg-test-weu.politepebble-ac325973.westeurope.azurecontainerapps.io",
  Prod: "https://ca-roles-privileges-cfg-prod-weu.livelyground-f686889f.westeurope.azurecontainerapps.io",
};

const scopes = {
  Local: ["api://bce6fe0a-8b23-4c09-97ef-15b87e832669/.default"],
  Dev: ["api://bce6fe0a-8b23-4c09-97ef-15b87e832669/.default"],
  Test: ["api://b997f88e-d76f-4184-9b7a-a43790b5b50a/.default"],
  Prod: ["api://a0130e3e-b818-444a-8269-26306d3a979e/.default"],
};

const applicationId = applicationIds[environment];
const authority =
  "https://login.microsoftonline.com/a6230a1c-393a-4c9e-9938-a643402658d9";
const postLogoutRedirectUri = postLogoutRedirectUris[environment];
const redirectUri = redirectUris[environment];

export const scope = scopes[environment];

export const msalConfig = {
  auth: {
    clientId: applicationId,
    authority: authority,
    knownAuthorities: [],
    cloudDiscoveryMetadata: "",
    redirectUri: redirectUri,
    postLogoutRedirectUri: postLogoutRedirectUri,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: "sessionStorage",
    temporaryCacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
    secureCookies: false,
    claimsBasedCachingEnabled: true,
  },
  system: {
    loggerOptions: {
      loggerCallback: (
        level: LogLevel,
        message: string,
        containsPii: boolean
      ): void => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
        }
      },
      piiLoggingEnabled: false,
    },
    windowHashTimeout: 60000,
    iframeHashTimeout: 6000,
    loadFrameTimeout: 0,
    asyncPopups: false,
  },
  telemetry: {
    application: {
      appName: "ConfigurationModule",
      appVersion: "0.0.2",
    },
  },
};
